// General function to perform depth search in any array of objects
function deepSearch(arr: any[], searchTerm: string): any[] {
  const lowerCaseSearchTerm = searchTerm.toLowerCase();

  // Recursive function to search deeply within objects and arrays
  const searchObject = (obj: any): boolean => {
    for (let key in obj) {
      if (typeof obj[key] === "object" && obj[key] !== null) {
        if (Array.isArray(obj[key])) {
          // If it's an array, search recursively in array items
          if (obj[key].some((item: any) => searchObject(item))) {
            return true;
          }
        } else {
          // If it's an object, search recursively in the object
          if (searchObject(obj[key])) {
            return true;
          }
        }
      } else if (typeof obj[key] === "string" || typeof obj[key] === "number") {
        // Convert values to strings and check if they contain the search term
        if (String(obj[key]).toLowerCase().includes(lowerCaseSearchTerm)) {
          return true;
        }
      }
    }
    return false;
  };

  // Filter the array by applying the recursive search to each object
  return arr.filter(searchObject);
}

export default deepSearch;
